export default __webpack_public_path__ + "bc39544761c2ad59dbff22c6713e0e7d.png";